import { useAzureToken } from '@internal/backstage-plugin-kaap';
import { armApiRef } from '@internal/plugin-azure-resources-common-react';
import React, { useState } from 'react';

import { useApi } from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { FormControl, FormHelperText, Link } from '@material-ui/core';

import { SelectInput } from './SelectInput';

type SecurityObject = {
  id: string;
  name: string;
};

type AbstractObject = { id: string; name: string };

export type SelectOption = {
  label: string;
  value: string;
  [key: string]: string | undefined;
};

export const makeOptionsForObjects = (o: AbstractObject[]): SelectOption[] =>
  [...o]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(x => ({ label: x.name, value: x.id }));

export const KaaPAzureSecurityGroupMultiValue = (
  props: FieldExtensionComponentProps<string[]>,
) => {
  const { onChange, formData } = props;
  const armApi = useApi(armApiRef);
  const { authProvider } = useAzureToken();
  const [error, setError] = useState(false);

  const getSecurityObjects = async (
    ids: string[],
    match?: string,
  ): Promise<SecurityObject[]> => {
    const groups = [];
    if (ids.length > 0)
      groups.push(...(await armApi.getGroups(authProvider, { ids })));
    groups.push(
      ...(await armApi.getGroups(
        authProvider,
        match ? { match } : { isMember: true },
      )),
    );
    const uniqueIds = new Set();
    return groups.filter(o => !uniqueIds.has(o.id) && uniqueIds.add(o.id));
  };

  const onchange = (change: string[]) => {
    onChange(change);
    setError(change.length === 0);
  };
  return (
    <FormControl fullWidth size="small" error={!formData}>
      <SelectInput
        id="security-object-ids"
        name="securityObjectIds"
        label="Security groups"
        value={formData! || []}
        options={async x =>
          makeOptionsForObjects(await getSecurityObjects(formData!, x))
        }
        multiple
        required
        onChange={onchange}
        error={error}
      />
      {error ? (
        <FormHelperText error>Security groups required</FormHelperText>
      ) : (
        <FormHelperText>
          <span>
            Select the{' '}
            <Link
              target="_blank"
              href="https://frontstage.tomtomgroup.com/docs/default/component/kaap-documentation/#create-a-tenant"
            >
              {' '}
              Azure Security groups{' '}
            </Link>{' '}
            that will have access to this tenant
          </span>
        </FormHelperText>
      )}
    </FormControl>
  );
};
